import AuthLayout from "@/layouts/AuthLayout";
import { useEffect } from "react";
import { localStorageWrapper } from "@/utils/storage";
import { useRouter } from "next/router";

export default function Page() {
    const router = useRouter();

    const goToLogin = () => router.push("/login");
    const goToRegister = () => router.push("/register");

    useEffect(() => {
        if ((window?.location?.search ?? "").indexOf("register") > -1) {
            goToRegister();
        } else {
            const token = localStorageWrapper.getToken();
            if (!!token) {
                router.push("/courses");
            } else {
                goToLogin();
            }
        }
    }, []);

    return <></>;
}

Page.getLayout = function getLayout(page) {
    return <AuthLayout>{page}</AuthLayout>;
};
